import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="top" className="relative min-h-screen flex items-center bg-paper pt-24 md:pt-28 pb-16 md:pb-20 px-6 md:px-10 overflow-hidden" data-id="element-51">
      <div className="max-w-7xl mx-auto w-full grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-52">
        {/* Image — first on mobile for cinematic open */}
        <motion.div initial={{
        opacity: 0,
        scale: 1.03
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="order-1 lg:order-2 lg:col-span-6 relative aspect-[4/5] sm:aspect-[3/4] lg:aspect-[3/4] overflow-hidden" data-id="element-53">
          <img src="https://images.unsplash.com/photo-1545158535-c3f7168c28b6?w=1200&q=80&auto=format&fit=crop" alt="Woman watching the ocean" className="absolute inset-0 w-full h-full object-cover" data-id="element-54" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/20 via-transparent to-transparent" data-id="element-55" />
        </motion.div>

        {/* Copy */}
        <div className="order-2 lg:order-1 lg:col-span-6" data-id="element-56">
          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.1
        }} className="font-serif-display text-[44px] sm:text-6xl lg:text-7xl leading-[1.04] text-ink" data-id="element-57">
            You don't need <br data-id="element-58" />
            a new life.
            <br data-id="element-59" />
            <span className="italic" data-id="element-60">
              You need a new <br data-id="element-61" />
              experience.
            </span>
          </motion.h1>

          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 1,
          delay: 0.7
        }} style={{
          transformOrigin: 'left'
        }} className="mt-8 md:mt-10 w-12 h-px bg-ink/40" data-id="element-62" />

          <motion.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.9
        }} className="mt-6 md:mt-8 max-w-md text-ink-soft text-[15px] leading-[1.85]" data-id="element-63">
            Something shifts when you put yourself somewhere new — around people
            you didn't plan to meet, in a place that feels a little unfamiliar,
            but somehow right.{' '}
            <span className="text-ink" data-id="element-64">This is where that happens.</span>
          </motion.p>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.9,
          delay: 1.2
        }} className="mt-10 md:mt-12 flex items-center gap-6" data-id="element-65">
            <a href="#waitlist" className="inline-flex items-center justify-center px-9 py-4 bg-ink text-bone text-[11px] uppercase tracking-[0.32em] hover:bg-accent transition-colors duration-500" data-id="element-66">
              Join the Waitlist
            </a>
            <p className="hidden sm:block eyebrow !text-muted" data-id="element-67">
              2027 · Costa Rica · Mexico · Portugal
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}